export function enumIncludesValue(obj: any, value: any): boolean {
  return Object.values(obj).some((v) => (value === v));
}
